var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 51,
    viewBox: "0 0 46 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.8787 50.1213C22.0503 51.2929 23.9497 51.2929 25.1213 50.1213L44.2132 31.0294C45.3848 29.8579 45.3848 27.9584 44.2132 26.7868C43.0416 25.6152 41.1421 25.6152 39.9706 26.7868L23 43.7574L6.02944 26.7868C4.85787 25.6152 2.95837 25.6152 1.7868 26.7868C0.615225 27.9584 0.615225 29.8579 1.7868 31.0294L20.8787 50.1213ZM20 1.31134e-07L20 48L26 48L26 -1.31134e-07L20 1.31134e-07Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.e8555624bd2af5d9e3961674a0647dde.svg";
export { ForwardRef as ReactComponent };